// extracted by mini-css-extract-plugin
export default {"container":"tiTy4feqjt8CCRFmUj9F"};